import { render, staticRenderFns } from "./ranking-table.component.vue?vue&type=template&id=ea36376a&scoped=true"
import script from "./ranking-table.component.vue?vue&type=script&lang=js"
export * from "./ranking-table.component.vue?vue&type=script&lang=js"
import style0 from "./ranking-table.component.vue?vue&type=style&index=0&id=ea36376a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea36376a",
  null
  
)

export default component.exports